// import dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import btnStyles from '~/common/components/CommonButton/common-button.css';

// import stylesheet
import styles from './number-card.css';

const NumberCard = ({ type, to, id, titleText, badgeAlt, badgeSrc, summaryText, dataTest, onClickCall }) => (
    <div className={styles.wrapper}>
        <div className={styles['summary-wrapper']}>
            <img
                alt={badgeAlt}
                className={styles.badge}
                src={badgeSrc}
            />
            <div className={styles.summary}>
                <h2 className={styles.title}>{titleText}</h2>
                <p className={styles['summary-text']}>
                    {summaryText}
                </p>
            </div>
        </div>
        <Link
            className={`${btnStyles.button} ${styles.button}`}
            data-test={dataTest}
            id={id}
            to={to}
            {...onClickCall && { onClick: onClickCall }}
        >
            {type === 'Transfer' ?
                <span>Keep<span className={styles['truncate-below-desktop']}> my Current</span> Number</span>
                :
                <span><span className={styles['truncate-below-desktop']}>Choose a </span>{type} Number</span>
            }
        </Link>
    </div>
);

NumberCard.propTypes = {
    type: PropTypes.string.isRequired,
    to: PropTypes.string,
    id: PropTypes.string,
    titleText: PropTypes.string,
    badgeAlt: PropTypes.string,
    badgeSrc: PropTypes.string,
    summaryText: PropTypes.string
};

export default NumberCard;
